/**
 * <section-product-favorites>
 *
 * Tracks PDP product in recently viewed on connect.
 * Markup: sections/section-product_favorites.liquid
 */

import { addRecentlyViewed } from '@theme/recently-viewed';

class SectionProductFavorites extends HTMLElement {
  #initialized = false;

  connectedCallback() {
    if (this.#initialized) return;
    this.#initialized = true;

    if (!this.hasAttribute('data-favorites-track-product')) return;

    const handle = this.dataset.handle;
    const productId = Number(this.dataset.productId);

    if (!handle || !productId) return;

    addRecentlyViewed({ handle, productId });
  }

  disconnectedCallback() {
    this.#initialized = false;
  }
}

if (!customElements.get('section-product-favorites')) {
  customElements.define('section-product-favorites', SectionProductFavorites);
}
